import { useEffect } from 'react';

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  if (target.closest('[data-barcode-scanner-input]')) {
    return false;
  }
  return (
    target.isContentEditable ||
    ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)
  );
}

export const useBarcodeScanner = (onScanBarcode: (barcode: string) => void) => {
  useEffect(() => {
    let scannedBarcode = '';
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const handleKeyDown = (event: KeyboardEvent) => {
      // Typing in a form must never be mistaken for a scan.
      if (isTypingTarget(event.target)) {
        scannedBarcode = '';
        return;
      }

      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        scannedBarcode = '';
      }, 500); // Most scanners finish within ~30-50ms

      if (event.key === 'Enter') {
        if (scannedBarcode) {
          onScanBarcode(scannedBarcode);
          scannedBarcode = '';
        }
      } else if (event.key?.length === 1) {
        scannedBarcode += event.key;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
    };
  }, [onScanBarcode]);
};
